export enum BlogUserEvents {
    ClickListItem = "Blog - Click List Item",
    ClickFeaturedPost = "Blog - Click Featured Post",
}
